
export default {
    name: "popup_build_the_beat",
    props: ["week"],
    data() {
        return {
            isLoading: false,
            isLoadingPlay: false,
            isLoadingInit: true,
            isStarted: false,
            isSubmitting: false,
            isShowInfo: true,
            isShowClosePopup: false,
            isGameFinished: false,
            isFullscreenBg: false,

            game: {
                width: 420,
                height: 770,
                defaultWidth: 420,
                defaultHeight: 770,
                scale: 1
            },

            BACKGROUND_COLOR: "#7ec8f2",

            TILE_PALETTE: ["#B6629C", "#298DC0", "#009383", "#61B6C1", "#EB9F57", "#E30613"],
            TILE_PALETTE_STEPS_BETWEEN: 6,
            TILE_HEIGHT: 26,
            TILE_INITIAL_WIDTH: 140,
            TILE_ISO_DEPTH: 75,
            TILE_DEPTH: 1.0,
            TILE_ISO_Y: 75 / 140,
            INITIAL_SPEED: 3,
            SPEED_INCREMENT: 0.22,
            SPEED_STEP_INTERVAL: 5,
            MAX_SPEED: 8,
            PERFECT_TOLERANCE: 3,
            CANVAS_WIDTH: 420,
            CANVAS_HEIGHT: 770,
            AUDIO_ENABLED: true,

            page: "landing",
            modal: null,
            paused: false,
            tutorialStep: 0,
            tutorial: [
                { titleKey: "tut1_title", textKey: "tut1_text", buttonKey: "nextBtn" },
                { titleKey: "tut2_title", textKey: "tut2_text", buttonKey: "tapBtn" },
                { titleKey: "tut3_title", textKey: "tut3_text", buttonKey: "nextBtn" },
                { titleKey: "tut4_title", textKey: "tut4_text", buttonKey: "nextBtn" },
                { titleKey: "tut5_title", textKey: "tut5_text", buttonKey: "finishHowToPlayBtn" }
            ],
            leaderboard: {
                isLoading: false,
                items: [],
                myItem: {}
            },
            gameId: null,
            serverWeek: 1,
            countdown: null,
            countdownInterval: null,
            rank: 0,

            selectedLang: "en",
            langText: {
                en: {
                    title: "Build the Beat",
                    fiestaLabel: "MyWellness Fiesta 2026",
                    highScoreLabel: "High Score: ",
                    currentRankLabel: "Current Rank: ",
                    introHeading: "How high can you stack?",
                    introDesc: "Stack wellness tiles, keep your rhythm and build your tower as high as you can. The higher you go, the faster it gets — stay focused, time your taps and aim for a high score!",
                    playBtn: "Play",
                    howToPlayBtn: "How to Play",
                    leaderboardBtn: "Rank",
                    skinBtn: "My Beat",
                    skinColorTitle: "Colour",
                    skinColorDesc: "Choose your colour and build the beat.",
                    skinIconTitle: "Special",
                    skinIconDesc: "Exclusive tiles unlocked as you rise through the ranks.",
                    backBtn: "Back",
                    nextBtn: "Next",
                    tapBtn: "Tap",
                    finishHowToPlayBtn: "Finish How to Play",
                    tut1_title: "Start the Beat",
                    tut1_text: "Watch the wellness tile move from side to side.",
                    tut1_rankIntro: "Keep stacking, build your score and rise from Opening Act to Wellness Rockstar. The higher your best score, the higher your rank — and new Special Tiles unlock as you progress.",
                    tut2_title: "Tap to Stack",
                    tut2_text: "Tap when the tile lines up with the tower to drop it into place.",
                    tut3_title: "Build It Higher",
                    tut3_text: "The better the alignment, the stronger your stack. Keep going and build your tower higher!",
                    tut4_title: "Stay in Rhythm",
                    tut4_text: "Miss the perfect alignment and your tile gets smaller — making the next move even trickier.",
                    tut5_title: "Set Your High Score",
                    tut5_text: "Keep stacking until you miss the tower. The higher you build, the higher you score.",
                    gameHighScoreLabel: "High Score: ",
                    finishBtn: "Finish",
                    leaderboardTitle: "Top Build the Beat players",
                    leaderboardDesc1: "Check out these weekly high scores and see where you stand! Can you rise to the top?",
                    leaderboardDesc2: "The top 100 players weekly will be awarded up to 50 MyWellness Points at the end of every week!",
                    positionCol: "Position",
                    nicknameCol: "Nickname",
                    scoreCol: "Score",
                    bonusCol: "Bonus points",
                    readyTitle: "Ready to start?",
                    readyText: "You can always come back to the instructions later.",
                    startGameBtn: "Start game",
                    keepReadingBtn: "Keep reading",
                    pausedTitle: "Game paused",
                    pausedText: "Take a moment. Ready to get back to the beat?",
                    resumeBtn: "Resume game",
                    quitGameBtn: "Quit game",
                    quitTitle: "Quit the game?",
                    quitText: "Your current run will be lost if you quit now.",
                    keepPlayingBtn: "Keep playing",
                    quitBtn: "Quit",
                    scoreCategories: [
                        { label: "Opening Act", text: "You're on stage - keep the beat going!" },
                        { label: "Rising Artist", text: "You've found your rhythm, Keep climbing!" },
                        { label: "Soloist", text: "You're hitting your stride.\nAim higher!" },
                        { label: "Headliner", text: "You're owning the stage.\nOne more level to go!" },
                        { label: "Wellness Rockstar", text: "You've hit the ultimate high note!" },
                        { label: "Bonus Streak", text: "Two in a row!\nEncore achieved! Two stellar runs in a row have unlocked a special reward." }
                    ],
                    skinUnlockConditions: [
                        "Score 1+",
                        "Score 31+",
                        "Score 51+",
                        "Score 76+",
                        "Score 101+",
                        "Score 101+\ntwice in a row"
                    ]
                },
                cn: {
                    title: "音律闯关",
                    fiestaLabel: "2026 健康嘉年华",
                    highScoreLabel: "最高得分：",
                    currentRankLabel: "当前排名：",
                    introHeading: "你的堆叠极限有多高？",
                    introDesc: "堆叠健康拼图、稳住闯关节奏，全力挑战更高堆叠高度。堆叠高度越高，拼图移动速度越快。保持专注、精准把控点击时机，冲刺高分！",
                    playBtn: "开始游戏",
                    howToPlayBtn: "玩法说明",
                    leaderboardBtn: "排行榜",
                    skinBtn: "我的音律",
                    skinColorTitle: "色彩样式",
                    skinColorDesc: "选择心仪色彩，开启音律闯关。",
                    skinIconTitle: "专属样式",
                    skinIconDesc: "提升闯关等级，解锁限定专属拼图。",
                    backBtn: "返回",
                    nextBtn: "下一步",
                    tapBtn: "点击",
                    finishHowToPlayBtn: "完成玩法说明",
                    tut1_title: "开启音律",
                    tut1_text: "观察健康拼图左右移动。",
                    tut1_rankIntro: "持续堆叠、累积分数，从「开场序曲」一路进阶至「健康巨星」。最高分越高，排位越高，还能陆续解锁全新特别拼图。",
                    tut2_title: "点击堆叠",
                    tut2_text: "当拼图与塔身对齐时点击屏幕，使拼图落下并完成堆叠。",
                    tut3_title: "层层攀升",
                    tut3_text: "对齐越精准，堆叠越稳固。持续挑战，堆出更高的塔楼！",
                    tut4_title: "稳住节奏",
                    tut4_text: "若未能精准对齐，拼图将被裁切，使下一块拼图更小、更难堆放。",
                    tut5_title: "刷新个人最高分",
                    tut5_text: "持续堆叠，直至拼图完全错位，挑战结束。塔楼越高，得分越高！",
                    gameHighScoreLabel: "最高分：",
                    finishBtn: "完成",
                    leaderboardTitle: "音律闯关顶尖玩家",
                    leaderboardDesc1: "查看这些每周高分，看看你排在哪里！你能登上顶端吗？",
                    leaderboardDesc2: "每周前 100 名玩家将在每周结束时获得最多 50 点 MyWellness 积分！",
                    positionCol: "位置",
                    nicknameCol: "昵称",
                    scoreCol: "分数",
                    bonusCol: "奖励积分",
                    readyTitle: "准备好了吗？",
                    readyText: "你随时可以回到说明页面。",
                    startGameBtn: "开始游戏",
                    keepReadingBtn: "继续阅读",
                    pausedTitle: "游戏暂停",
                    pausedText: "休息一下。准备好回到节奏中了吗？",
                    resumeBtn: "继续游戏",
                    quitGameBtn: "退出游戏",
                    quitTitle: "退出游戏？",
                    quitText: "如果你现在退出，当前进度将会丢失。",
                    keepPlayingBtn: "继续游戏",
                    quitBtn: "退出",
                    scoreCategories: [
                        { label: "开场序曲", text: "登台伊始，保持律动不止！" },
                        { label: "新星崛起", text: "已然找准节奏，继续向上攀升！" },
                        { label: "独奏登场", text: "状态正佳，步履从容。\n志存高远，冲击更高！" },
                        { label: "压轴主场", text: "掌控全场，闪耀舞台。\n仅剩最后一级，冲刺巅峰！" },
                        { label: "健康巨星", text: "奏响终极高光旋律，登顶巅峰！" },
                        { label: "连胜奖励", text: "连续两次高分通关！\n成功解锁加场福利！连续两轮斩获绝佳成绩，解锁专属特别奖励。" }
                    ],
                    skinUnlockConditions: [
                        "分数 1+",
                        "分数 31+",
                        "分数 51+",
                        "分数 76+",
                        "分数 101+",
                        "连续两次\n分数 101+"
                    ]
                }
            },

            scoreRanges: ["1-30", "31-50", "51-75", "76-100", "101+"],

            state: "menu",
            score: 0,
            scoreCategoryIndex: 0,
            best: 0,
            combo: 0,
            blocks: [],
            falling: [],
            current: null,
            cameraY: 0,
            cameraTarget: 0,
            lastTs: 0,
            raf: 0,
            bgImg: null,
            sounds: {},

            perfectFlash: null,
            scorePopup: null,

            skinTab: "color",
			selectedColor: 1,
			selectedIcon: 0,
			unlockedIcons: [],
			iconList: [1, 2, 3, 4, 5, 6],
			iconImg: null
        }
    },
    computed: {
        tutorialTower() {
            const step = this.tutorialStep;
            const n = step <= 1 ? 36 : step === 2 ? 38 : 41;
            const out = [];

            for (let i = 0; i < n; i++) {
                let w = 1;
                if (step >= 3) {
                    if (i === n - 1 || i === n - 2) w = 0.70;
                    else if (i === n - 3) w = 0.84;
                }
                out.push({
                    i, ox: 0, w,
                    colors: this.colorFor(i, true),
                    total: n,
                    step
                });
            }
            return out;
        },
        skinPreviewTower() {
            const n = 28;
            const out = [];

            for (let i = 0; i < n; i++) {
                out.push({
                    i, ox: 0, w: 1,
                    colors: this.colorFor(i),
                    total: n,
                    isSkin: true
                });
            }
            return out;
        },
        modalConfig() {
            const t = this.langText[this.selectedLang] || this.langText.en;
            const configs = {
                ready: {
                    title: t.readyTitle,
                    text: t.readyText,
                    buttons: [
                        { label: t.startGameBtn, primary: true, action: this.onClickPlayBtn },
                        { label: t.keepReadingBtn, primary: false, action: this.openTutorial }
                    ]
                },
                paused: {
                    title: t.pausedTitle,
                    text: t.pausedText,
                    buttons: [
                        { label: t.resumeBtn, primary: true, action: this.resumeGame },
                        { label: t.quitGameBtn, primary: false, action: () => { this.modal = "quit"; } }
                    ]
                },
                quit: {
                    title: t.quitTitle,
                    text: t.quitText,
                    buttons: [
                        { label: t.keepPlayingBtn, primary: true, action: this.resumeGame },
                        { label: t.quitBtn, primary: false, action: this.quitGame }
                    ]
                }
            };
            return configs[this.modal] || null;
        },
        scoreCategory() {
            const cats = this.langText[this.selectedLang].scoreCategories;
            return cats[this.scoreCategoryIndex] || cats[0];
        },
        scoreRanks() {
            return this.langText[this.selectedLang].scoreCategories.slice(0, this.scoreRanges.length);
        }
    },
    mounted() {
        this.onReCalcGameSize();
        this.initAudio();
        this.loadBg();
        this.iconList.forEach(n => this.loadIcon(n));
        this.fetchInitData();
        window.addEventListener("keydown", this.onKey);
        this.loop = this.loop.bind(this);
        this.raf = requestAnimationFrame(this.loop);
    },
    beforeDestroy() {
        cancelAnimationFrame(this.raf);
        window.removeEventListener("keydown", this.onKey);
        if(this.countdownInterval) clearInterval(this.countdownInterval);
    },
    watch: {
        winW: "onReCalcGameSize",
        winH: "onReCalcGameSize",
    },
    methods: {
        flattenText(text){
            return `${ text }`.split(String.fromCharCode(10)).join(" ");
        },
        fetchInitData() {
            this.isLoadingInit = true;
            this.$axios.$post("/build_the_beat/init", {}, this.tokenHeader).then(res => {
                this.best = res.highscore || 0;
                this.rank = res.rank || 0;
                this.unlockedIcons = res.unlocked || [];
                this.loadSkinSelection();
                if(this.selectedIcon > 0 && !this.isIconUnlocked(this.selectedIcon)){
                    this.selectedIcon = 0;
                }
                this.isLoadingInit = false;
            }).catch(err => {
                console.error("buildTheBeatInitError", err);
                this.loadSkinSelection();
                this.isLoadingInit = false;
            });
        },
        loadSkinSelection() {
            try {
                const saved = localStorage.getItem(`${ process.env.cookieName }_build_the_beat_skin`);
                if(saved){
                    const parsed = JSON.parse(saved);
                    if(parsed.color) this.selectedColor = parsed.color;
                    if(parsed.icon) this.selectedIcon = parsed.icon;
                }
            } catch(e) {}
        },
        saveSkinSelection() {
            try {
                localStorage.setItem(`${ process.env.cookieName }_build_the_beat_skin`, JSON.stringify({
                    color: this.selectedColor,
                    icon: this.selectedIcon
                }));
            } catch(e) {}
        },
        noop() { },
        onReCalcGameSize() {
            const { defaultWidth, defaultHeight } = this.game;
            const isPortrait = this.winH > this.winW;

            this.isFullscreenBg = this.winW < 500 && isPortrait;

            const scaleFactor = this.isFullscreenBg ? 1 : 0.9;
            const widthScale = (this.winW * scaleFactor) / defaultWidth;
            const heightScale = (this.winH * scaleFactor) / defaultHeight;
            const scale = Math.min(widthScale, heightScale);

            this.game = {
                ...this.game,
                scale
            };
        },
        onRefresh() {
            if (this.page !== "game") location.reload();
        },
        openTutorial() {
            this.modal = null;
            this.tutorialStep = 0;
            this.page = "tutorial";
        },
        nextTutorial() {
            if (this.tutorialStep < this.tutorial.length - 1) this.tutorialStep += 1;
            else this.page = "landing";
        },
        hexToRgb(hex) {
            const h = String(hex).replace("#", "");
            return {
                r: parseInt(h.slice(0, 2), 16),
                g: parseInt(h.slice(2, 4), 16),
                b: parseInt(h.slice(4, 6), 16)
            };
        },
        lerp(a, b, t) { return a + (b - a) * t; },
        mixHex(a, b, t) {
            const A = this.hexToRgb(a), B = this.hexToRgb(b);
            return {
                r: Math.round(this.lerp(A.r, B.r, t)),
                g: Math.round(this.lerp(A.g, B.g, t)),
                b: Math.round(this.lerp(A.b, B.b, t))
            };
        },
        paletteHex(layer, forceRainbow = false) {
            if (!forceRainbow && this.selectedColor >= 1) {
                const skinColors = [...this.TILE_PALETTE].reverse();
                return skinColors[this.selectedColor - 1] || skinColors[0];
            }

            const stops = this.TILE_PALETTE;
            const n = stops.length;
            const between = this.TILE_PALETTE_STEPS_BETWEEN;
            const segLen = between + 1;
            const period = n * segLen;
            const t = ((layer % period) + period) % period;
            const seg = Math.floor(t / segLen);
            const local = t % segLen;
            const from = stops[seg];
            const to = stops[(seg + 1) % n];
            const rgb = this.mixHex(from, to, local / segLen);
            const hex = (c) => c.toString(16).padStart(2, "0");
            return `#${hex(rgb.r)}${hex(rgb.g)}${hex(rgb.b)}`;
        },
        tutorialTopAnchor(step) {
            if (step <= 1) return 12;
            return -40;
        },
        tutorialIsoY(ly) {
            let topY = this.tutorialTopAnchor(ly.step ?? 0);
            if (ly.isSkin) topY = 12;
            const total = ly.total || 8;
            return topY + ((total - 1) - ly.i) * this.TILE_HEIGHT;
        },
        tutorialIsoYTopVertex(ly) {
            const baseY = this.tutorialIsoY(ly);
            const w = ly.w || 1;
            return baseY - this.TILE_ISO_DEPTH * (1 - w);
        },
        isoTop(ly) {
            const cx = 160 + (ly.ox || 0);
            const y = this.tutorialIsoYTopVertex(ly);
            const s = this.TILE_INITIAL_WIDTH * (ly.w || 1);
            const d = this.TILE_ISO_DEPTH * (ly.w || 1);
            return `${cx},${y - d} ${cx + s},${y} ${cx},${y + d} ${cx - s},${y}`;
        },
        isoLeft(ly) {
            const cx = 160 + (ly.ox || 0);
            const y = this.tutorialIsoYTopVertex(ly);
            const s = this.TILE_INITIAL_WIDTH * (ly.w || 1);
            const d = this.TILE_ISO_DEPTH * (ly.w || 1);
            const h = this.TILE_HEIGHT;
            return `${cx - s},${y} ${cx},${y + d} ${cx},${y + d + h} ${cx - s},${y + h}`;
        },
        isoRight(ly) {
            const cx = 160 + (ly.ox || 0);
            const y = this.tutorialIsoYTopVertex(ly);
            const s = this.TILE_INITIAL_WIDTH * (ly.w || 1);
            const d = this.TILE_ISO_DEPTH * (ly.w || 1);
            const h = this.TILE_HEIGHT;
            return `${cx + s},${y} ${cx},${y + d} ${cx},${y + d + h} ${cx + s},${y + h}`;
        },
        pauseGame() {
            if (this.state !== "playing") return;
            this.paused = true;
            this.modal = "paused";
        },
        resumeGame() {
            this.modal = null;
            this.paused = false;
        },
        quitGame() {
            this.modal = null;
            this.paused = false;
            this.state = "menu";
            this.current = null;
            this.page = "landing";
            this.isStarted = false;
            this.isGameFinished = false;
            this.gameId = null;
        },
        startGame() {
            this.modal = null;
            this.page = "game";
            this.paused = false;
            this.isGameFinished = false;
            this.state = "menu";
            this.score = 0;
            this.scoreCategoryIndex = 0;
            this.combo = 0;
            this.blocks = [];
            this.falling = [];
            this.perfectFlash = null;
            this.scorePopup = null;
            this.current = null;
            this.cameraY = 0;
            this.cameraTarget = 0;
            this.$nextTick(() => this.startCountdown());
        },
        async onClickPlayBtn() {
            if(this.isLoadingPlay || this.isStarted) return;
            this.isLoadingPlay = true;
            try {
                const res = await this.$axios.$post("/build_the_beat/start", {
                    icon: this.selectedIcon
                }, this.tokenHeader);
                this.gameId = res.gameId;
                this.serverWeek = res.week;
                if(res.highscore !== undefined) this.best = res.highscore;
                if(res.icon !== undefined) this.selectedIcon = res.icon;
                this.isLoadingPlay = false;
                this.isStarted = true;
                this.startGame();
                this.onHandleTriggerAnalytics(`play@build_the_beat`);
            } catch(err) {
                this.isLoadingPlay = false;
                console.error("buildTheBeatStartError", err);
                return this.onHandleApiError(err);
            }
        },
        startCountdown() {
            let count = 3;
            this.countdown = count;
            this.countdownInterval = setInterval(() => {
                count--;
                if (count > 0) {
                    this.countdown = count;
                } else {
                    clearInterval(this.countdownInterval);
                    this.countdownInterval = null;
                    this.countdown = null;
                    this.start();
                }
            }, 700);
        },
        async onSubmitResult() {
            if(this.isSubmitting) return;
            this.isSubmitting = true;
            try {
                const res = await this.$axios.$post("/build_the_beat/submit", {
                    gameId: this.gameId,
                    score: this.score,
                    hash: this.hashData(`${ this.gameId }${ this.score }`)
                }, this.tokenHeader);
                this.isSubmitting = false;
                if(res.rank !== undefined) this.rank = res.rank;
                if(res.unlocked) this.unlockedIcons = res.unlocked;
                if(res.stamp) this.$store.commit("stamp/addItem", res.stamp);
                if(res.scoreCategory !== undefined) this.scoreCategoryIndex = res.scoreCategory;
                this.onHandleTriggerAnalytics(`${this.score} scored`)
            } catch(err) {
                console.error("buildTheBeatSubmitError", err);
                this.isSubmitting = false;
                return this.onHandleApiError(err);
            }
        },
        onClickExitGameBtn() {
            this.isShowInfo = true;
            this.isStarted = false;
            this.isGameFinished = false;
            this.isShowClosePopup = false;
            this.gameId = null;
            this.page = "landing";
            this.countdown = null;
            if(this.countdownInterval) clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        },
        loadBg() {
            const img = new Image();
            img.onload = () => { this.bgImg = img; };
            img.src = this.formattedAssetUrl(`static/images/build_the_beat/bg.png`);
        },
        loadIcon(name) {
            if (!name) return null;
            if (this.iconImg && this.iconImg[name]) return this.iconImg[name];
            if (!this.iconImg) this.iconImg = {};
            const img = new Image();
            img.onload = () => { this.iconImg[name] = img; };
            img.src = this.formattedAssetUrl(`static/images/build_the_beat/icon/${ name }.png`);
            return null;
        },
        initAudio() {
            if (!this.AUDIO_ENABLED || typeof Howl === "undefined") return;
            const mk = (freq, dur, type) => this.synthWav(freq, dur, type);
            this.sounds.place = new Howl({ src: [mk(420, 0.08, "sine")], volume: 0.35 });
            this.sounds.perfect = new Howl({ src: [mk(720, 0.12, "triangle")], volume: 0.4 });
            this.sounds.combo = new Howl({ src: [mk(880, 0.18, "square")], volume: 0.35 });
            this.sounds.fail = new Howl({ src: [mk(140, 0.35, "sawtooth")], volume: 0.4 });
        },
        synthWav(freq, duration, wave) {
            const sr = 22050;
            const n = Math.floor(sr * duration);
            const buf = new ArrayBuffer(44 + n * 2);
            const v = new DataView(buf);
            const w = (o, s) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); };
            w(0, "RIFF"); v.setUint32(4, 36 + n * 2, true); w(8, "WAVEfmt ");
            v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
            v.setUint32(24, sr, true); v.setUint32(28, sr * 2, true); v.setUint16(32, 2, true);
            v.setUint16(34, 16, true); w(36, "data"); v.setUint32(40, n * 2, true);
            for (let i = 0; i < n; i++) {
                const t = i / sr;
                const env = Math.min(1, i / 200) * Math.max(0, 1 - i / n);
                const ph = 2 * Math.PI * freq * t;
                let s;
                if (wave === "square") s = Math.sign(Math.sin(ph));
                else if (wave === "sawtooth") s = 2 * ((freq * t) % 1) - 1;
                else if (wave === "triangle") s = 2 * Math.abs(2 * ((freq * t) % 1) - 1) - 1;
                else s = Math.sin(ph);
                v.setInt16(44 + i * 2, s * env * 0.7 * 32767, true);
            }
            const bytes = new Uint8Array(buf);
            let bin = "";
            for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
            return "data:audio/wav;base64," + btoa(bin);
        },
        play(name) {
            if (!this.AUDIO_ENABLED || !this.sounds[name]) return;
            try { this.sounds[name].play(); } catch (e) { }
        },
        colorFor(layer, forceRainbow = false) {
            const hex = this.paletteHex(layer, forceRainbow);
            const { r, g, b } = this.hexToRgb(hex);
            const adj = (f) => {
                const clamp = (n) => Math.max(0, Math.min(255, Math.round(n)));
                return `rgb(${clamp(r * f)},${clamp(g * f)},${clamp(b * f)})`;
            };
            return {
                top: `rgb(${r},${g},${b})`,
                right: adj(0.85),
                left: adj(0.65),
                glow: `rgba(${r},${g},${b},.55)`
            };
        },
        project(x, z, y) {
            const k = this.TILE_DEPTH;
            const isoY = this.TILE_ISO_Y || 0.58;
            return {
                x: (x - z) * k,
                y: (x + z) * k * isoY - y
            };
        },
        origin() {
            return {
                x: this.CANVAS_WIDTH / 2,
                y: this.CANVAS_HEIGHT * 0.5 + this.cameraY
            };
        },
        start() {
            this.state = "playing";
            this.score = 0;
            this.combo = 0;
            this.falling = [];
            this.perfectFlash = null;
            this.scorePopup = null;
            this.cameraY = 0;
            this.cameraTarget = 0;
            const s = this.TILE_INITIAL_WIDTH;
            this.blocks = [{
                x: -s / 2, z: -s / 2, sx: s, sz: s,
                origX: -s / 2, origZ: -s / 2, origSx: s, origSz: s,
                y: 0, layer: 0, pulse: 0
            }];
            this.spawnNext();
        },
        spawnNext() {
            const prev = this.blocks[this.blocks.length - 1];
            const layer = prev.layer + 1;
            const axis = layer % 2 === 1 ? "x" : "z";
            const speed = Math.min(
                this.MAX_SPEED,
                this.INITIAL_SPEED + Math.floor(this.score / this.SPEED_STEP_INTERVAL) * this.SPEED_INCREMENT
            );
            const travel = this.TILE_INITIAL_WIDTH * 1.8;
            const block = {
                x: prev.x, z: prev.z, sx: prev.sx, sz: prev.sz,
                origX: prev.x, origZ: prev.z, origSx: prev.sx, origSz: prev.sz,
                y: prev.y + this.TILE_HEIGHT,
                layer, axis, dir: 1, speed, pulse: 0
            };
            if (axis === "x") {
                block.x = prev.x - travel;
                block.origX = block.x;
            } else {
                block.z = prev.z - travel;
                block.origZ = block.z;
            }
            this.current = block;
            this.cameraTarget = (layer - 1) * this.TILE_HEIGHT;
        },
        onKey(e) {
            if (e.code === "Escape" && this.page === "game" && this.state === "playing") {
                this.pauseGame();
                return;
            }
            if (e.code === "Space" || e.key === " ") {
                e.preventDefault();
                this.onTap();
            }
        },
        onTap() {
            if (this.page !== "game" || this.paused || this.modal) return;
            if (this.state !== "playing" || !this.current) return;
            this.place();
        },
        place() {
            const cur = this.current;
            const prev = this.blocks[this.blocks.length - 1];
            const a = cur.axis;
            const s = a === "x" ? "sx" : "sz";
            const c0 = cur[a], c1 = cur[a] + cur[s];
            const p0 = prev[a], p1 = prev[a] + prev[s];
            const o0 = Math.max(c0, p0), o1 = Math.min(c1, p1);
            const overlap = o1 - o0;

            const origX = cur.x, origZ = cur.z, origSx = cur.sx, origSz = cur.sz;

            if (overlap <= 0.4) {
                this.falling.push(this.makeFall(cur, cur.dir * 2.4, 0.04 * cur.dir));
                this.current = null;
                this.play("fail");
                this.state = "over";
                if (this.score > this.best) {
                    this.best = this.score;
                }
                this.isGameFinished = true;
                this.isStarted = false;
                this.onSubmitResult();
                return;
            }

            const perfect = Math.abs(cur[a] - prev[a]) <= this.PERFECT_TOLERANCE;
            const placed = {
                x: prev.x, z: prev.z, sx: prev.sx, sz: prev.sz,
                origX: perfect ? prev.x : origX,
                origZ: perfect ? prev.z : origZ,
                origSx: perfect ? prev.sx : origSx,
                origSz: perfect ? prev.sz : origSz,
                y: cur.y, layer: cur.layer, pulse: 0
            };

            if (perfect) {
                placed[a] = prev[a];
                placed[s] = prev[s];
                placed.pulse = 1;
                this.combo += 1;
                this.play(this.combo % 5 === 0 ? "combo" : "perfect");

                this.perfectFlash = { life: 1, y: placed.y };

                if (this.combo > 0 && this.combo % 5 === 0) {
                    this.score += 5;
                    this.scorePopup = { life: 1, text: "+5" };
                }
            } else {
                this.combo = 0;
                this.play("place");
                placed[a] = o0;
                placed[s] = overlap;
                placed.origX = origX;
                placed.origZ = origZ;
                placed.origSx = origSx;
                placed.origSz = origSz;

                if (c0 < p0 - 0.2) {
                    const piece = {
                        x: cur.x, z: cur.z, sx: cur.sx, sz: cur.sz, y: cur.y, layer: cur.layer,
                        origX, origZ, origSx, origSz
                    };
                    piece[a] = c0; piece[s] = p0 - c0;
                    this.falling.push(this.makeFall(piece, -2.6, -0.05));
                }
                if (c1 > p1 + 0.2) {
                    const piece = {
                        x: cur.x, z: cur.z, sx: cur.sx, sz: cur.sz, y: cur.y, layer: cur.layer,
                        origX, origZ, origSx, origSz
                    };
                    piece[a] = p1; piece[s] = c1 - p1;
                    this.falling.push(this.makeFall(piece, 2.6, 0.05));
                }
            }

            this.blocks.push(placed);
            this.score += 1;
            this.current = null;
            this.spawnNext();
        },
        makeFall(b, vAlong, vr) {
            return {
                x: b.x, z: b.z, sx: b.sx, sz: b.sz,
                origX: b.origX, origZ: b.origZ, origSx: b.origSx, origSz: b.origSz,
                y: b.y, layer: b.layer,
                vx: b.axis === "z" ? 0 : vAlong,
                vz: b.axis === "z" ? vAlong : 0,
                vy: 0.6, rot: 0, vr, axis: b.axis || "x"
            };
        },
        loop(ts) {
            const dt = Math.min(32, ts - (this.lastTs || ts));
            this.lastTs = ts;
            this.update(dt);
            this.draw();
            this.raf = requestAnimationFrame(this.loop);
        },
        update(dt) {
            if (this.page !== "game" || this.paused) return;
            const t = dt / 16.67;
            this.cameraY += (this.cameraTarget - this.cameraY) * 0.08 * t;

            if (this.state === "playing" && this.current) {
                const c = this.current;
                const a = c.axis;
                c[a] += c.dir * c.speed * t;
                const prev = this.blocks[this.blocks.length - 1];
                const center = prev[a];
                const span = this.TILE_INITIAL_WIDTH * 1.2;
                if (c[a] > center + span) { c[a] = center + span; c.dir = -1; }
                if (c[a] < center - span) { c[a] = center - span; c.dir = 1; }
                if (a === "x") c.origX = c.x;
                else c.origZ = c.z;
            }

            for (const b of this.blocks) {
                if (b.pulse > 0) b.pulse = Math.max(0, b.pulse - 0.045 * t);
            }
            for (const f of this.falling) {
                f.vy += 0.35 * t;
                f.y -= f.vy * t * 2.2;
                f.x += (f.vx || 0) * t;
                f.z += (f.vz || 0) * t;
                f.rot += (f.vr || 0) * t;
            }
            this.falling = this.falling.filter(f => f.y > -400);

            if (this.perfectFlash) {
                this.perfectFlash.life -= 0.02 * t;
                if (this.perfectFlash.life <= 0) this.perfectFlash = null;
            }
            if (this.scorePopup) {
                this.scorePopup.life -= 0.015 * t;
                if (this.scorePopup.life <= 0) this.scorePopup = null;
            }
        },
        drawBg(ctx, w, h) {
            if (!this.bgImg) {
                ctx.fillStyle = this.BACKGROUND_COLOR;
                ctx.fillRect(0, 0, w, h);
                return;
            }

            const img = this.bgImg;
            const scale = Math.max(w / img.width, h / img.height);
            const dw = img.width * scale;
            const dh = img.height * scale;
            const drawX = (w - dw) / 2;

            const maxScroll = Math.max(0, dh - h);
            const speedFactor = 0.2;
            const scroll = Math.min(maxScroll, Math.max(0, this.cameraY * speedFactor));
            const drawY = (h - dh) + scroll;

            ctx.drawImage(img, drawX, drawY, dw, dh);
        },
        drawIconOnFace(ctx, topN, topE, topS, topW, sx = 140, sz = 140) {
            const name = this.selectedIcon;
            if (!name || name < 1) return;
            const img = this.iconImg && this.iconImg[name];
            if (!img) return;

            const iw = img.naturalWidth || img.width || 1;
            const ih = img.naturalHeight || img.height || 1;
            const arImg = iw / ih;
            const maxWorldSize = 0.85 * Math.min(sx, sz);

            let worldW, worldL;
            if (arImg >= 1) {
                worldW = maxWorldSize;
                worldL = maxWorldSize / arImg;
            } else {
                worldL = maxWorldSize;
                worldW = maxWorldSize * arImg;
            }

            const scaleU = worldW / sz;
            const scaleV = worldL / sx;

            const offU = (1 - scaleU) / 2;
            const offV = (1 - scaleV) / 2;

            const ux = topN.x - topW.x, uy = topN.y - topW.y;
            const vx = topS.x - topW.x, vy = topS.y - topW.y;

            ctx.save();
            ctx.transform(
                ux * scaleU, uy * scaleU,
                vx * scaleV, vy * scaleV,
                topW.x + ux * offU + vx * offV,
                topW.y + uy * offU + vy * offV
            );
            ctx.globalAlpha = 0.95;
            ctx.drawImage(img, 0, 0, 1, 1);
            ctx.restore();
        },
        drawBlock(ctx, b, o) {
            const colors = this.colorFor(b.layer);
            const x0 = b.x, z0 = b.z, x1 = b.x + b.sx, z1 = b.z + b.sz;
            const yTop = b.y;
            const yBot = b.y - this.TILE_HEIGHT;
            const p = (x, z, y) => {
                const s = this.project(x, z, y);
                return { x: o.x + s.x, y: o.y + s.y };
            };
            const topN = p(x0, z0, yTop);
            const topE = p(x1, z0, yTop);
            const topS = p(x1, z1, yTop);
            const topW = p(x0, z1, yTop);
            const botE = p(x1, z0, yBot);
            const botS = p(x1, z1, yBot);
            const botW = p(x0, z1, yBot);

            ctx.save();
            if (b.rot) {
                const c = p((x0 + x1) / 2, (z0 + z1) / 2, (yTop + yBot) / 2);
                ctx.translate(c.x, c.y);
                ctx.rotate(b.rot);
                ctx.translate(-c.x, -c.y);
            }
            const face = (pts, fill) => {
                ctx.beginPath();
                ctx.moveTo(pts[0].x, pts[0].y);
                for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i].x, pts[i].y);
                ctx.closePath();
                ctx.fillStyle = fill;
                ctx.fill();
            };
            face([topW, topS, botS, botW], colors.left);
            face([topE, topS, botS, botE], colors.right);
            face([topN, topE, topS, topW], colors.top);
            ctx.beginPath();
            ctx.moveTo(topN.x, topN.y);
            ctx.lineTo(topE.x, topE.y);
            ctx.lineTo(topS.x, topS.y);
            ctx.lineTo(topW.x, topW.y);
            ctx.closePath();
            ctx.strokeStyle = "rgba(255,255,255,.18)";
            ctx.lineWidth = 1;
            ctx.stroke();

            if (b.pulse > 0) {
                ctx.save();
                ctx.globalAlpha = b.pulse * 0.55;
                ctx.shadowColor = colors.glow;
                ctx.shadowBlur = 20;
                face([topN, topE, topS, topW], colors.glow);
                ctx.restore();
            }

            ctx.save();
            ctx.beginPath();
            ctx.moveTo(topN.x, topN.y);
            ctx.lineTo(topE.x, topE.y);
            ctx.lineTo(topS.x, topS.y);
            ctx.lineTo(topW.x, topW.y);
            ctx.closePath();
            ctx.clip();

            const fx0 = b.origX !== undefined ? b.origX : b.x;
            const fz0 = b.origZ !== undefined ? b.origZ : b.z;
            const fsx = b.origSx !== undefined ? b.origSx : b.sx;
            const fsz = b.origSz !== undefined ? b.origSz : b.sz;

            const fullTopN = p(fx0, fz0, yTop);
            const fullTopE = p(fx0 + fsx, fz0, yTop);
            const fullTopS = p(fx0 + fsx, fz0 + fsz, yTop);
            const fullTopW = p(fx0, fz0 + fsz, yTop);

            this.drawIconOnFace(ctx, fullTopN, fullTopE, fullTopS, fullTopW, fsx, fsz);
            ctx.restore();

            ctx.restore();
        },
        skinIconTransform(ly) {
            const cx = 160 + (ly.ox || 0);
            const y = this.tutorialIsoYTopVertex(ly);
            const s = this.TILE_INITIAL_WIDTH * (ly.w || 1);

            const topN = { x: cx,     y: y - this.TILE_ISO_DEPTH * (ly.w || 1) };
            const topE = { x: cx + s, y: y };
            const topW = { x: cx - s, y: y };
            const topS = { x: cx,     y: y + this.TILE_ISO_DEPTH * (ly.w || 1) };

            const sx = s;
            const sz = s;

            const name = this.selectedIcon;
            const img = this.iconImg && this.iconImg[name];

            let arImg = 1;
            if (img) {
                const iw = img.naturalWidth || img.width || 1;
                const ih = img.naturalHeight || img.height || 1;
                arImg = iw / ih;
            }

            const maxWorldSize = 0.85 * Math.min(sx, sz);

            let worldW, worldL;
            if (arImg >= 1) {
                worldW = maxWorldSize;
                worldL = maxWorldSize / arImg;
            } else {
                worldL = maxWorldSize;
                worldW = maxWorldSize * arImg;
            }

            const scaleU = worldW / sz;
            const scaleV = worldL / sx;

            const offU = (1 - scaleU) / 2;
            const offV = (1 - scaleV) / 2;

            const ux = topN.x - topW.x, uy = topN.y - topW.y;
            const vx = topS.x - topW.x, vy = topS.y - topW.y;

            const a = ux * scaleU;
            const b = uy * scaleU;
            const c = vx * scaleV;
            const d2 = vy * scaleV;
            const e = topW.x + ux * offU + vx * offV;
            const f = topW.y + uy * offU + vy * offV;

            return `matrix(${a} ${b} ${c} ${d2} ${e} ${f})`;
        },
        draw() {
            if (this.page !== "game") return;
            const canvas = this.$refs.cv;
            if (!canvas) return;
            const ctx = canvas.getContext("2d");
            const w = this.CANVAS_WIDTH;
            const h = this.CANVAS_HEIGHT;
            ctx.clearRect(0, 0, w, h);
            this.drawBg(ctx, w, h);
            const o = this.origin();
            if (this.blocks.length) {
                const base = this.blocks[0];
                const c = this.project(base.x + base.sx / 2, base.z + base.sz / 2, 0);
                ctx.save();
                ctx.globalAlpha = 0.18;
                ctx.fillStyle = "#000";
                ctx.beginPath();
                ctx.ellipse(o.x + c.x, o.y + c.y + 10, base.sx * this.TILE_DEPTH * 0.72, base.sz * this.TILE_DEPTH * 0.36, 0, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
            for (const b of this.blocks) this.drawBlock(ctx, b, o);
            if (this.current) this.drawBlock(ctx, this.current, o);
            for (const f of this.falling) this.drawBlock(ctx, f, o);

            if (this.perfectFlash) {
                const fl = this.perfectFlash;
                const py = o.y - fl.y;
                ctx.save();
                ctx.globalAlpha = Math.max(0, Math.min(1, fl.life));
                ctx.fillStyle = "#DF2F3B";
                ctx.font = "bold 24px Geomanist, sans-serif";
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.strokeStyle = "#FFFFFF";
                ctx.lineWidth = 4;
                ctx.lineJoin = "round";
                ctx.strokeText("PERFECT!", w / 2, py);
                ctx.fillText("PERFECT!", w / 2, py);
                ctx.restore();
            }
        },
        onClickCloseBtn() {
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@build_the_beat`);
        },
        onClickLeaderboardBtn() {
            this.page = "leaderboard";
            this.leaderboard.isLoading = true;
            this.$axios.$post("/build_the_beat/leaderboard", {}, this.tokenHeader).then(res => {
                this.leaderboard.myItem = res.myItem;
                this.leaderboard.items = res.leaderboard;
                this.leaderboard.isLoading = false;
            }).catch(err => {
                console.error("buildTheBeatLeaderboardError", err);
                return this.onHandleApiError(err);
            });
            this.onHandleTriggerAnalytics(`open@leaderboard@build_the_beat`);
        },
        onClickSkinBtn() {
            this.skinTab = "color";
            this.page = "skin";
        },
        onSelectColor(i){
            this.selectedColor = i;
            this.saveSkinSelection();
        },
        onSelectIcon(i){
            if(i > 0 && !this.isIconUnlocked(i)) return;
            this.selectedIcon = i;
            this.saveSkinSelection();
        },
        isIconUnlocked(i){
            if(i === 0) return true;
            return this.unlockedIcons.includes(`icon_${ i }`);
        },
        onCalcBonusPoints(index) {
            return Math.max(0, Math.round((100 - index) / 2));
        },
    },
}
